import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  FormGroup,
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator,
} from '../../../components/form/';

import WorkingHours from '../../../components/form/WorkingHours';
import ArtisanBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';
import {
  currentUserSelector,
  usersAsValueAndLabelSelectors,
  usersIsLoadingSelector,
} from '../../../modules/users/Selectors';
import { globalFail } from '../../../modules/globalFail/Selector';
import {
  artisanCategoriesAsLabelAndValueSelector,
  artisanCategoriesIsLoadingSelector,
} from '../../../modules/artisanCategories/Selectors';
import {
  supplierCategoriesAsLabelAndValueSelector,
  supplierCategoriesListSelector,
} from '../../../modules/supplierCategories/Selectors';
// import schema from '../TrainingCenter/TrainingCenterSchema';
import Tci18nBlock from '../../../components/form/i18nForm/FormBIOi18n';
import { setRedirectFalse } from '../../../modules/globalFail/Action';
import { getArtisanCategoriesAction } from '../../../modules/artisanCategories/Actions';
import { getSupplierCategoriesAction } from '../../../modules/supplierCategories/Actions';
import { newErrorNotificationAction } from '../../../modules/notifications/Actions';
import {
  addtrainingCenterCourseAction,
  createTrainingCenterAction,
  editTrainingCenterCourseAction,
  getSingleTrainingCenterAction,
  getTrainingCentersAction,
  updateTrainingCenterAction,
} from '../../../modules/trainingCenter/Actions';
import setWizardPage from '../../../helpers/setWizardPage';
import {
  currentTrainingCenter,
  currentTrainingCenterCourses,
  currnetTrainingCenterCourseById,
  trainingCenterByIdSelectro,
  trainingCenterLoading,
} from '../../../modules/trainingCenter/Selectors';
import { getUsersAction } from '../../../modules/users/Actions';
import * as Yup from 'yup';
import getLangData from '../../../utils/getLangData';
// import { getSingleTrainingCenter } from '../../../modules/trainingCenter/Api';

const options = [
  {
    value: '0',
    label: 'Blue Collar',
  },
  {
    value: '1',
    label: 'Artisan',
  },
];

const schema = () =>
  Yup.object({
    /*     geolocation: Yup.array().of(Yup.number()).default([30.093529617886073,31.340912898477427]),
     */

    name: Yup.string()
      .default('')
      .required(getLangData().fields.required),

    description: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    duration: Yup.string().default('')
      .required(getLangData().fields.required),
    cost: Yup.number().moreThan(0)
      .default(1)
      .required(getLangData().fields.required),
    registerLink: Yup.string().url()
      //       .matches(
      //  ^(?:https?:|s?ftps?://)?(?!www | www\.)[A-Za-z0-9_-]+\.+[A-Za-z0-9.\/%&=\?_:;-]+$,
      //         'Enter correct url!'
      //       )
      .default('')
      .required(getLangData().fields.required),
  });

const TrainingCenterCourseForm = (props) => {
  const {
    trainingCenterData,
    currentUser,
    artisanCategories,
    supplierCategories,
    getArtisanCategories,
    getSupplierCategories,
    categoriesIsloading,
    errorNotification,
    createTrainingCenter,
    updateTrainingCenter,
    page,
    setPage,
    edit,
    redirectFalse,
    reload,
    fail,
    getTrainingCenter,
    tsid,
    getSingleTrainingCenter,
    getUsers,
    mappedUsers,
    usersIsLodaing,
    isLoading,
    course,
    addCourse,
    editCourse,
  } = props;
  const params = useParams();
  const lang = getLangData().fields
  useEffect(() => {
    // getTrainingCenter();

    if (params.id) {
      getSingleTrainingCenter(params.id);
    }
  }, []);
  const history = useHistory();

  console.log(course);
  // useEffect(() => {
  //   if (!edit) {
  //     fail && setWizardPage(page, '8', setPage);
  //     redirectFalse();
  //   }
  //   if (reload) {
  //     fail && window.location.reload();
  //   }
  // }, [fail]);

  return (
    <Formik
      enableReinitialize
      initialValues={course ? { ...course } : schema().cast()}
      validationSchema={schema()}
      onSubmit={(values) => {
        if (course) {
          editCourse({
            ...values,
            trainingCenterId: params.id,
            courseId: params.cid,
          });
        } else {
          addCourse({ ...values, trainingCenterId: params.id });
        }
      }}
    >
      {({ handleSubmit, values, errors }) => (
        <FormGroup
          errors={errors}
          isLoading={isLoading}
          heading={
            trainingCenterData
              ? lang.update_training_center_course
              : lang.create_training_center_course
          }
          handleSubmit={handleSubmit}
        >
          {/* {console.log(trainingCenterData)} */}
          <FormSectionTitle>{lang.basic_information}:</FormSectionTitle>
          {/* "trainingCenterId": "5fd8a21ae27844002c131f43",
	"name": "nodejs course",
	"description": "lorem ipsum",
	"duration": "3",
	"cost": 10,
	"registerLink": "http://localhost:register" */}
          <InputField name="name" label={lang.name} />
          {/* <Tci18nBlock name="businessi18n" description="Business Name" /> */}
          <TextArea name="description" label={lang.descrition} />
          {/* <Tci18nBlock name="tci18n" description="BIO" /> */}
          <Separator />{' '}
          {/* <Upload
            data={{ userID: currentUser._id }}
            name="logo"
            label="Profile Logo :"
            S3Bucket="warshatna-users"
            // API="customer/customer-category-image-signedurl/"
            API="users/user-profile-image-signedurl"
          /> */}
          <InputField name="duration" label={lang.duration} />
          <InputField name="cost" label={lang.cost} type="number" />
          <InputField name="registerLink" label={lang.register_link} />
          {
            // Bio
          }
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const tsid = props.match.params.id;
  const ccid = props.match.params.cid;
  console.log('di', ccid);
  return {
    currentUser: currentUserSelector(state),
    fail: globalFail(state),
    artisanCategories: artisanCategoriesAsLabelAndValueSelector(state),
    supplierCategories: supplierCategoriesListSelector(state),
    categoriesIsloading: artisanCategoriesIsLoadingSelector(state),
    // trainingCenterData: trainingCenterByIdSelectro(state, id),
    trainingCenterData: currentTrainingCenter(state),
    usersIsLodaing: usersIsLoadingSelector(state),
    mappedUsers: usersAsValueAndLabelSelectors(state),
    isLoading: trainingCenterLoading(state),
    tsid,
    ccid,
    course: currnetTrainingCenterCourseById(state, ccid),
  };
};

const mapDispatchToProps = {
  addCourse: addtrainingCenterCourseAction,
  editCourse: editTrainingCenterCourseAction,
  errorNotification: newErrorNotificationAction,

  getSingleTrainingCenter: getSingleTrainingCenterAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrainingCenterCourseForm);
